export default __webpack_public_path__ + "success.1f778a0c.png";